import PropTypes from 'prop-types';
import { useCallback, useEffect } from 'react';
// routes
import { paths } from 'src/routes/paths';
import { useRouter, useSearchParams } from 'src/routes/hooks';
//
import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

export default function GuestGuard({ children }) {
  const router = useRouter();
  const { authenticated, user } = useAuthContext();
  const searchParams = useSearchParams();

  // Function to determine the user's role
  const getUserRole = () => {
    if (user?.is_admin) return 'admin';
    if (user?.is_academic) return 'academic';
    // if (user?.is_non_academic) return user?.non_academic_role;
    if (user?.is_non_academic) return 'non_academic';
    if (user?.is_student) return 'student';
    if (user?.is_parent) return 'parent';
    if (user?.is_height_student) return 'height_student';
    if (user?.is_outsider) return 'outsider';
    if (user?.is_guest_user || user?.is_guest) return 'guest_user';

    return null;
  };

  const role = getUserRole();

  const roleBasedPaths = {
    admin: paths.dashboard.root,
    academic: paths.dashboard.general.academicdashboard,
    student: paths.studentdashboard.studentprofile.root,
    non_academic: paths.dashboard.general.nonacademicdashboard,
    parent: paths.parentdashboard.root,
    height_student: paths.heightstudentdashboard.root,
    outsider: paths.outsiderdashboard.root,
    guest_user: paths.guestdashboard.root,
  };


  const PATH = (role && roleBasedPaths[role]) ? roleBasedPaths[role] : paths.dashboard.root;

  const returnTo = searchParams.get('returnTo') || PATH;

  const check = useCallback(() => {
    if (authenticated) {
      router.replace(returnTo);
    }
  }, [authenticated, returnTo, router]);

  useEffect(() => {
    check();
  }, [check]);

  return <>{children}</>;
}

GuestGuard.propTypes = {
  children: PropTypes.node,
};
